import api from '../../api/api'
import url from '../../api/env'
import Utils from '../../utils/Utils'

const read = async (filterName, pageNumber, excludeChars = true, sort_type = 'desc') =>
  api
    .get(excludeChars ? `${url.stage.companies}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.companies}?per_page=${pageNumber}&name=%${filterName}%`), {})
    .then(res => { return res })
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const readByCompanyId = async companyId =>
  api
    .get(`${url.stage.companies}/${companyId}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const enterpriseNextPage = async urlNextPage =>
  api
    .get(`${urlNextPage}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const enterpriseDelete = async companyId =>
  api
    .remove(`${url.stage.companies}/${companyId}`, {})
    .then(res => res)
    .catch(err => err)

const saveCompany = async data =>
  api
    .post(url.stage.companies, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const updateCompany = async (data, companyId) =>
  api
    .put(`${url.stage.companies}/${companyId}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
  read,
  readByCompanyId,
  enterpriseNextPage,
  enterpriseDelete,
  saveCompany,
  updateCompany,
}
